function Leftnav() {
  return <></>;
}

export default Leftnav;
